import React from "react";
import { history } from "../../../Healper/history";

function PatientPreliminaryCode(props) {
  return (
    <>
      <div className="mx-auto px-2">
        <div
          style={{ marginTop: "10px" }}
          className=" col-md-12 col-sx-12 col-lg-12 col-sm-12"
        >
          <div className="card">
            <div className="card-header cardHeaderColor">
              <div className="card-title">Covid-19 Pre-registration Code</div>
              <div className="custom-card-title "></div>
            </div>
            <div className="card-body">
              <form>
                <div>
                  <div className="row">
                    <div className="form-group col-12 ">
                      <label>
                        Your registration code is:
                        <strong style={{ textTransform: "capitalize" }}>
                          {props.location.state.code}
                        </strong>
                      </label>
                    </div>
                    <div className="form-group col-12 ">
                      <label>
                        <strong>Necessary Step: </strong>Please provide this
                        code to the Covid sampling facility to finalize your
                        registration. Thank you.
                      </label>
                    </div>
                    <div className="form-group col-12 ">
                      <label>
                        If you have provided an email address during your
                        registration, we have already sent an email to you
                        containing your registration code.
                      </label>
                    </div>
                    <div className="mt-3 col-xs-6 col-sm-6 col-lg-2 offset-lg-5 col-md-2 offset-md-5">
                      <button
                        className="btn  btn-block btn-primary "
                        type="button"
                        onClick={() => {
                          history.push("/");
                        }}
                      >
                        Return to home
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default PatientPreliminaryCode;
